import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../components/config";

const Auditoria = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [logSeleccionado, setLogSeleccionado] = useState(null);

  /* ======================================================
     📌 CARGAR LOGS (CORREGIDO)
  ====================================================== */
  const cargarLogs = async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");

      const res = await axios.get(`${API}/auditoria`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // 🔥 FIX: soporta backend tipo { ok, data }
      const data = res.data?.data || res.data || [];

      if (!Array.isArray(data)) {
        throw new Error("Respuesta inválida del servidor");
      }

      setLogs(data);
    } catch (error) {
      console.error("❌ Error cargando auditoría:", error);
      setError("No se pudieron cargar los registros de auditoría");
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  /* ======================================================
     📌 MODAL
  ====================================================== */
  const abrirDetalle = (log) => {
    setLogSeleccionado(log);
    setModalOpen(true);
  };

  const cerrarModal = () => {
    setModalOpen(false);
    setLogSeleccionado(null);
  };

  /* ======================================================
     📌 JSON SAFE FORMAT
  ====================================================== */
  const formatearJSON = (data) => {
    try {
      if (!data) return "Sin datos";

      const json =
        typeof data === "string" ? JSON.parse(data) : data;

      return JSON.stringify(json, null, 2);
    } catch (err) {
      return String(data);
    }
  };

  /* ======================================================
     📌 SEVERIDAD
  ====================================================== */
  const getBadgeSeveridad = (severidad) => {
    switch (severidad) {
      case "CRITICA":
        return "bg-danger";
      case "ALTA":
        return "bg-warning text-dark";
      case "MEDIA":
        return "bg-info text-dark";
      default:
        return "bg-secondary";
    }
  };

  /* ======================================================
     📌 INIT
  ====================================================== */
  useEffect(() => {
    cargarLogs();
  }, []);

  /* ======================================================
     📌 LOADING
  ====================================================== */
  if (loading) {
    return (
      <div className="container mt-4">
        <div className="card shadow-sm border-0">
          <div className="card-body text-center p-5">
            <h4>⏳ Cargando auditoría...</h4>
          </div>
        </div>
      </div>
    );
  }

  /* ======================================================
     📌 ERROR UI
  ====================================================== */
  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger text-center">
          <h5>{error}</h5>
          <button className="btn btn-dark mt-2" onClick={cargarLogs}>
            🔄 Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">🔍 Auditoría del Sistema</h2>
          <p className="text-muted mb-0">
            Registro completo de acciones del sistema
          </p>
        </div>

        <button className="btn btn-primary" onClick={cargarLogs}>
          🔄 Recargar
        </button>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <div className="table-responsive">

            <table className="table table-bordered table-hover align-middle">
              <thead className="table-dark">
                <tr>
                  <th>ID</th>
                  <th>Usuario</th>
                  <th>Acción</th>
                  <th>Módulo</th>
                  <th>IP</th>
                  <th>Severidad</th>
                  <th>Fecha</th>
                  <th>Detalle</th>
                </tr>
              </thead>

              <tbody>
                {logs.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  logs.map((log) => (
                    <tr key={log.id}>
                      <td>{log.id}</td>

                      <td>
                        <div className="fw-semibold">
                          {log.usuario_nombre || "N/A"}
                        </div>
                        <small className="text-muted">
                          {log.rol || "Sin rol"}
                        </small>
                      </td>

                      <td>
                        <span className="badge bg-primary">
                          {log.accion}
                        </span>
                      </td>

                      <td>{log.modulo}</td>
                      <td>{log.ip || "N/A"}</td>

                      <td>
                        <span
                          className={`badge ${getBadgeSeveridad(
                            log.severidad
                          )}`}
                        >
                          {log.severidad || "INFO"}
                        </span>
                      </td>

                      <td>
                        {log.created_at
                          ? new Date(log.created_at).toLocaleString()
                          : "N/A"}
                      </td>

                      <td>
                        <button
                          className="btn btn-dark btn-sm"
                          onClick={() => abrirDetalle(log)}
                        >
                          👁 Ver
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

          </div>
        </div>
      </div>

      {/* MODAL */}
      {modalOpen && logSeleccionado && (
        <div
          className="modal d-block"
          style={{ background: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content border-0 shadow-lg">

              {/* HEADER */}
              <div className="modal-header bg-dark text-white">
                <div>
                  <h5 className="modal-title">🔍 Detalle Auditoría</h5>
                  <small>ID: {logSeleccionado.id}</small>
                </div>

                <button
                  className="btn-close btn-close-white"
                  onClick={cerrarModal}
                />
              </div>

              {/* BODY */}
              <div className="modal-body bg-light">
                <div className="row">

                  {/* INFO */}
                  <div className="col-md-5">
                    <div className="card shadow-sm border-0">
                      <div className="card-header bg-primary text-white">
                        Información
                      </div>

                      <div className="card-body">
                        <p><b>Usuario:</b> {logSeleccionado.usuario_nombre}</p>
                        <p><b>Rol:</b> {logSeleccionado.rol}</p>
                        <p><b>Acción:</b> {logSeleccionado.accion}</p>
                        <p><b>Módulo:</b> {logSeleccionado.modulo}</p>
                        <p><b>IP:</b> {logSeleccionado.ip}</p>
                      </div>
                    </div>
                  </div>

                  {/* JSON */}
                  <div className="col-md-7">

                    <div className="card mb-3">
                      <div className="card-header bg-danger text-white">
                        Anterior
                      </div>
                      <pre className="p-2 bg-dark text-light">
                        {formatearJSON(logSeleccionado.valor_anterior)}
                      </pre>
                    </div>

                    <div className="card">
                      <div className="card-header bg-success text-white">
                        Nuevo
                      </div>
                      <pre className="p-2 bg-dark text-light">
                        {formatearJSON(logSeleccionado.valor_nuevo)}
                      </pre>
                    </div>

                  </div>

                </div>
              </div>

              {/* FOOTER */}
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={cerrarModal}>
                  Cerrar
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Auditoria;